import PropTypes from "prop-types";
import Tag from "@shared/v2/Tag";
import { getStatusClass } from "@shared/StatusDropdown/StatusDropdown";
import { ANY_STATUS_VALUE } from "./helpers";

// Values copied from OptionsStatusCell.scss; its `.pill-*` globals key off "comingsoon" and set no color.
const TRANSACTION_STATUS_PILL_CLASSES = {
  pipeline: "!tw-bg-[#ffa826] !tw-text-white",
  "coming soon": "!tw-bg-[#75c2c3] !tw-text-white",
  active: "!tw-bg-[#ebb562] !tw-text-white",
  pending: "!tw-bg-[#e27757] !tw-text-white",
  sold: "!tw-bg-[#416d79] !tw-text-white",
  expired: "!tw-bg-[#3b3b3b] !tw-text-white",
  withdrawn: "!tw-bg-[#3b3b3b] !tw-text-white",
  canceled: "!tw-bg-[#3b3b3b] !tw-text-white",
  archived: "!tw-bg-[#b3b3b3] !tw-text-white",
};

// "Any Status" is not a real status, so it keeps Tag's neutral styling; unknown values fall back the same.
export const getAutoPauseStatusPillClass = (planType, value) => {
  if (value === ANY_STATUS_VALUE) return "";

  return planType === "people" ? getStatusClass(value) : TRANSACTION_STATUS_PILL_CLASSES[value] || "";
};

// IconButton hardcodes a gray, so force currentColor; 11px keeps the glyph inside its 16px button.
const REMOVE_ICON = "[&>button]:!tw-text-current [&>button]:!tw-text-11d";

// Both need "!" — Tailwind emits font-bold after font-semibold, so Tag's base wins on source order.
const LABEL_TYPE = "!tw-text-14d !tw-font-semibold";

// Tag is an inline-flex with no align-items, so the 16px remove button hangs at the top without this.
const BOX = "!tw-h-[28px] tw-items-center";

// Swaps out the color class, not layered (equal specificity); border-solid explicit as preflight is off.
const DISABLED_PILL =
  "!tw-bg-white !tw-text-neutral-gray-30 !tw-border !tw-border-solid !tw-border-neutral-gray-15 [&>button]:tw-pointer-events-none";

const AutoPauseStatusPill = ({ planType, option, isDisabled = false, onRemove }) => (
  <Tag
    className={`${
      isDisabled ? DISABLED_PILL : getAutoPauseStatusPillClass(planType, option.value)
    } ${LABEL_TYPE} ${BOX} ${REMOVE_ICON}`}
    onRemove={() => !isDisabled && onRemove(option.value)}
  >
    {option.label}
  </Tag>
);

AutoPauseStatusPill.propTypes = {
  planType: PropTypes.string.isRequired,
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  isDisabled: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
};

export default AutoPauseStatusPill;
